
export {} from '@clayui/panel';
import __x__ from '@clayui/panel';export default __x__;